import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/imgs/icon-modal-confirm.svg'
import _imports_1 from '@/assets/imgs/icon-modal-success.svg'
import _imports_2 from '@/assets/imgs/icon-modal-error.svg'


const _withScopeId = n => (_pushScopeId("data-v-2475ba0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal"
}
const _hoisted_2 = {
  key: 0,
  class: "loader loading"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "content"
}
const _hoisted_6 = {
  key: 1,
  src: _imports_0
}
const _hoisted_7 = {
  key: 2,
  src: _imports_1
}
const _hoisted_8 = {
  key: 3,
  src: _imports_2
}
const _hoisted_9 = { class: "text" }
const _hoisted_10 = { class: "text" }
const _hoisted_11 = {
  key: 5,
  class: "actions"
}
const _hoisted_12 = {
  key: 6,
  class: "actions"
}
const _hoisted_13 = {
  key: 7,
  class: "actions"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (_ctx.isVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.type === 'loader')
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", null, [
                    (_ctx.type !== 'confirm')
                      ? (_openBlock(), _createBlock(_component_ButtonComponent, {
                          key: 0,
                          "style-type": "icon",
                          type: "button",
                          class: "close icon-close",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.type === 'confirm')
                      ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                      : _createCommentVNode("", true),
                    (_ctx.type === 'success' || _ctx.type === 'success-and-confirm')
                      ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                      : _createCommentVNode("", true),
                    (_ctx.type === 'error')
                      ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                      : _createCommentVNode("", true),
                    (_ctx.type == 'success' || _ctx.type == 'error')
                      ? (_openBlock(), _createElementBlock("h4", {
                          key: 4,
                          class: _normalizeClass(["title", 'title-' + _ctx.type])
                        }, _toDisplayString(_ctx.title), 3))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.message), 1),
                    _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.subMessage), 1),
                    (_ctx.type == 'confirm')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createVNode(_component_ButtonComponent, {
                            "style-type": "cancel",
                            type: "button",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeModal()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("admin.common.cancel")), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ButtonComponent, {
                            "style-type": "confirm",
                            type: "button",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirmModal()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("admin.common.continue")), 1)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.type == 'success-and-confirm')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createVNode(_component_ButtonComponent, {
                            "style-type": "cancel",
                            type: "button",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeModal()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.translate("not")), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ButtonComponent, {
                            "style-type": "confirm",
                            type: "button",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.confirmModal()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.translate("yes")), 1)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.type == 'content')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createVNode(_component_ButtonComponent, {
                            "style-type": "new",
                            type: "button",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.confirmModal()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.translate("close")), 1)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])),
            _createElementVNode("div", {
              class: "backdrop",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.closeModal()))
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}